import { AspectRatio, PersonAdd } from '@mui/icons-material';
import { CircularProgress, IconButton } from '@mui/material';
import { ModalPendingFriendInvitation } from 'primary/activities/Modals/ModalPendingFriendsInvitation';
import { Title } from 'primary/Components/Title/Title';
import { useContextDependency } from 'primary/hooks/useContextDependency';
import { useRetrieveFromDomain } from 'primary/hooks/useRetrieveFromDomain';
import React, { useState } from 'react';

export const ButtonInvitationsFriend = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { relationRepository } = useContextDependency();
  const [invitationList, , loading, retry] = useRetrieveFromDomain(
    () => relationRepository.getAllPendingRelationsOfConnectedUser(),
    undefined,
  );

  const afterSubmit = () => {
    retry();
    if (invitationList?.length && invitationList.length - 1 === 0) {
      setIsOpen(false);
    }
  };

  return (
    <div className={'-socialItems'}>
      <div className={'-iconWithNumber'}>
        <PersonAdd className={'-socialLogo'} />
        {!invitationList && <CircularProgress size={15} color={'info'} />}
        {invitationList && <span>{invitationList?.length ?? 0}</span>}
      </div>
      <div className={'-titleWithBtn'}>
        <Title title={'Invitations amis'} level={3} compensatePadding />
        <IconButton
          disabled={invitationList && invitationList.length <= 0}
          onClick={() => setIsOpen(true)}
        >
          <AspectRatio fontSize={'small'} />
        </IconButton>
      </div>
      {!invitationList && <CircularProgress size={15} color={'info'} />}
      {invitationList && (
        <ModalPendingFriendInvitation
          isOpen={isOpen}
          invitationList={invitationList}
          afterSubmit={afterSubmit}
          handleClose={() => setIsOpen(false)}
          loading={loading}
        />
      )}
    </div>
  );
};
